import { HOST } from "../constants/HostConstants";

export const adminCreatePromotion = async (user_id, impressions = 7500) => {
  try {
    const response = await fetch(`${HOST}/api/promotion/adminCreate`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id,
        impressions,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to create profile promotion");
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating profile promotion:", error);
    throw error;
  }
};
